<template>
  <v-main>
    <v-container fluid>
      <v-row class="ma-0">
        <v-spacer />
        <v-btn icon href="https://www.youtube.com/playlist?list=PL2a9kD1kP16fwIVRI9SzcRK81OVG2WY7C">
          <v-icon>mdi-video</v-icon>
        </v-btn>
      </v-row>

      <v-row>
        <v-col cols="8">
          <v-card shaped>
            <v-card-title class="titulo_card">{{ $t("Newsletter") }}</v-card-title>
            <v-card-text>
              <FormNewsletter ref="form_newsletter" />
            </v-card-text>
          </v-card>
        </v-col>

        <v-col cols="4">
          <v-card shaped>
            <v-card-title class="titulo_card">{{ $t("Seleccione los clientes") }}</v-card-title>
            <v-card-text>
              <ClientesCampaign @on_update_clientes_seleccionados="update_clientes_seleccionados" />
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

    </v-container>
  </v-main>
</template>

<script>
export default {
  name: "NuevoNewsletter",
  methods: {
    /**
     * Cuando se actualiza los clientes seleccionados del newsletter, lo actualizamos también el form
     * @param clientes
     */
    update_clientes_seleccionados(clientes){
      this.$refs.form_newsletter.update_clientes(clientes)
    }
  },
  components: {
    FormNewsletter: () => import('@/views/Marketing/components/FormNewsletter'),
    ClientesCampaign: () => import('@/views/Marketing/components/ClientesCampaign')
  }
}
</script>
